import {Component, Input, OnInit, Renderer2} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {HostingService} from "../../hosting.service";
import {HostingDomainData} from "../../domains/hostingDomainData";
import {FormControl, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {Website} from "../../../website";
import {SSlFailedDialogComponent} from "../ssl-failed-dialog/ssl-failed-dialog.component";
import { filter, first } from "rxjs";

export interface IEnableHttpsData {
  website: Website;
  selectedDialog: string;
  websiteIp: string;
  allDomains: HostingDomainData[];
}
@Component({
    selector: 'db-enable-https',
    templateUrl: './enable-https.component.html',
    styleUrls: ['./enable-https.component.scss'],
    standalone: false
})
export class EnableHttpsComponent extends DialogComponent<IEnableHttpsData, Boolean> implements OnInit, IEnableHttpsData {

  @Input() website: Website;
  @Input() selectedDialog: string;
  @Input() websiteIp: string;
  @Input() allDomains: HostingDomainData[] | any;
  public isMobile: boolean;
  public loading: boolean;
  public domains: FormControl;
  public generateCustomCertificate: FormGroup;
  public generateFreeCertificateForm: FormGroup;
  public domainNameIds: any;
  public serverErrors: DbServerErrors;
  public helpCenter: string;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>,
    private _hostingService: HostingService,
    private renderer: Renderer2
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.domains = new FormControl("");
    this.helpCenter = "https://help.10web.io/hc/en-us/articles/360027855951-How-to-Point-Your-Domain-to-10Web";
    this.checkDomains();
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  public addClass(event) {
    this.domainNameIds = [];
    const generateHttpsInput = event.target as HTMLInputElement;
    const parentEl = generateHttpsInput.parentElement.parentElement.parentElement.parentElement;

    if (parentEl.classList.contains('db-disabled')) {
      return;
    }

    const domainDivs = document.querySelectorAll('.db-domains div');
    domainDivs.forEach(div => this.renderer.removeClass(div, 'checked'));

    const elementValue = generateHttpsInput.value;
    const elementParent = generateHttpsInput.parentElement.parentElement;
    this.renderer.addClass(elementParent, 'checked');

    this.domainNameIds.push(elementValue);
  }

  public generateFreeCertificate(): void {
    this.loading = true;
    this.serverErrors = null;
    let isCloudflare = false;
    this._hostingService.generateFreeCertificate(this.website.multisiteType === 'subfolder' ? this.website.children[0] : this.website.id, this.domainNameIds, 1)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          NotifierComponent.notify(new Notification("Certificate created successfully", NotificationType.SUCCESS));
          this._store.dispatch(new fromStore.LoadCloudflareDefaultRecord(this.website.id));
          this.result = true;
          this.close();
        }
        else {
          this.domainNameIds.map((domain) => {
            const _domain = this.allDomains.find((__domain) => __domain.id == domain);
            if (_domain && _domain.pointed === 0 && _domain.server === 'cloudflare') {
              isCloudflare = true;
            }
          });
          if (isCloudflare) {
            this._dialogService.addDialog(SSlFailedDialogComponent);
            this.close();
          } else {
            this.serverErrors = response.serverErrors;
          }
        }
      });
  }


  public checkDomains(): void {
    this.loading = true;
    const domain_ids = this.allDomains.reduce((domainIds: any[], domain: any) => {
      domainIds.push(domain.id);
      return domainIds;
    }, []);
    this._hostingService.checkPointedDomain(this.website.multisiteType === 'subfolder' ? this.website.children[0] : this.website.id, domain_ids)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;
        if (response.success) {
          if (response.data && response.data.troubleshoot_result) {
            this.allDomains.map((domain: any) => {
              const domainId = domain.id;
              if (response.data.troubleshoot_result[domainId]) {
                domain.pointed = response.data.troubleshoot_result[domainId].domain_pointed;
                domain.server = response.data.troubleshoot_result[domainId].server;
              }
            });
          }
        }
        else {
          this.serverErrors = response.serverErrors;
        }
      });
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

}
